import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-sm text-gray-600 mb-8">
              <strong>Effective Date:</strong> August 2024
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Accounts & Use</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Must be 18+ and authorized to bind your organization.</li>
                <li>Keep credentials secure.</li>
                <li>You own your infrastructure data; Civioniks processes it under contract.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Services & Fees</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Subscription and service fees per order form.</li>
                <li>Auto-renewal unless canceled.</li>
                <li>Taxes may apply under GCC law.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Restrictions</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>No reverse engineering, reselling, or misuse.</li>
                <li>No uploading unlawful or harmful content.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Data Handling</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Infrastructure health monitoring data is processed securely.</li>
                <li>No secondary use beyond service delivery.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Confidentiality</h2>
              <p className="text-gray-700 leading-relaxed">
                Each party protects the other's confidential info.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Security</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Civioniks implements ISO/SOC-aligned controls.</li>
                <li>Customers must configure user access securely.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Liability</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Neither party liable for indirect damages.</li>
                <li>Liability capped at 12 months' service fees.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Governing Law</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>For GCC projects: Laws of the Kingdom of Saudi Arabia (or local GCC jurisdiction as agreed).</li>
                <li>For international: Ontario, Canada.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Termination</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>For breach or non-payment after notice.</li>
                <li>Data returned or deleted per retention rules.</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;